import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40f6a430"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "UserMsg-info"
}
const _hoisted_2 = {
  key: 0,
  class: "UserMsg-info-level"
}

import { computed, ref } from 'vue'
import { t } from '@/plugins/i18n'
import { useStore } from 'vuex'
import { useRtfix, isEN, useSite, isJA } from '@/store'
import { useRouter } from 'vue-router'
import SvgIcon from '@/components/icons/SvgIcon.vue'
import { isFirstPayVipApi } from '@/apis/usercenter'


export default /*#__PURE__*/_defineComponent({
  emits: ['changeType'],
  setup(__props, { emit: emits }) {

const store = useStore()
const router = useRouter()
const user = computed(() => store.getters.user)
const icon: any = {
  0: '经济舱',
  1: '铂金舱',
  2: '商务舱',
  3: '头等舱'
}



// 导航栏切换
const changeType = (index: number) => {

}

const isFirstVip = ref(false) // 是否开通过会员
const getFirstVip = () => {
  isFirstPayVipApi({}).then((res) => {
    // false：未开通会员
    if (!res.data) {
      isFirstVip.value = true
    }
  })
}
getFirstVip()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["UserMsg", _unref(useSite)()])
  }, [
    _createElementVNode("div", {
      class: "UserMsg-avatar hover rel",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push(_unref(useRtfix)('UserCenter'))))
    }, [
      _createVNode(SvgIcon, {
        class: "wrap rel",
        name: "头像",
        style: {"z-index":"1","font-size":"30px"}
      }),
      _createVNode(SvgIcon, {
        name: icon[_unref(user).membership?.templateLevel ?? 0],
        style: {"position":"absolute","left":"-5px","top":"-5px","font-size":"40px"}
      }, null, 8, ["name"])
    ]),
    (_unref(user))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "UserMsg-info-name hover",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push(_unref(useRtfix)('UserCenter'))))
          }, [
            _createElementVNode("span", null, _toDisplayString(_unref(user)?.loginName), 1),
            _createTextVNode(_toDisplayString(_unref(t)('様')), 1)
          ]),
          (_unref(user).membership)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("span", {
                  class: "hover",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push(_unref(useRtfix)('VipLevel'))))
                }, _toDisplayString(_unref(user).membership?.templateLevel === 0 ? (isFirstVip.value ? _unref(t)('未入会') :
              _unref(t)('已失去会員')) : _unref(user).membership?.membershipTemplateName), 1),
                _withDirectives(_createElementVNode("span", {
                  class: _normalizeClass(["gotoMt", _unref(useSite)()]),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(router).push(_unref(useRtfix)('VipLevel'))))
                }, _toDisplayString(_unref(t)('升级会员')), 3), [
                  [_vShow, _unref(isJA)() ? (_unref(user).membership?.templateLevel !== 5 && _unref(user).membership?.templateLevel !== 4) : _unref(user).membership?.templateLevel !== 3]
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})